import React from 'react';
import { Container, Box, css, Link } from 'theme-ui';
import Reveal from '@solid-ui-components/Reveal';
import Divider from '@solid-ui-components/Divider';
import ContentText from '@solid-ui-components/ContentText';
import Icon from '@solid-ui-components/ContentIcon';
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent';

const styles = {
  container: {
    textAlign: 'center',
    py: '49px',
    background: 'linear-gradient(94.64deg, #1A98D8 0%, #026AA2 100%)',
    borderRadius: '24px',
  },
  textBlock: {
    m: 'auto',
    mx: ['102px', 0, 0, 0, 0, '102px'],
  },
  buttonContainer: {
    border: '1px solid #FFFFFF',
    backgroundColor: '#fff',
    py: '13px',
    px: '16px',
    display: 'flex',
    gap: '8px',
    width: 'fit-content',
    mx: 'auto',
    borderRadius: '8px',
    textDecoration: 'none',
    transition: 'all ease 250ms',
    '&:hover': {
      backgroundColor: 'transparent',
      border: '1px solid #FFFFFF',
      '& p': {
        color: '#fff',
      },
      '& path': {
        stroke: '#fff',
      },
    },
  },
  button: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '30px',
    color: '#026AA2',
    m: 0,
    transition: 'all ease 250ms',
  },
};

const FeaturesBlock07 = ({ content: { text, collection, buttons } }) => (
  <Container css={css(styles.container)}>
    <Box sx={{ ...styles.textBlock }}>
      <ContentText content={text} />
    </Box>
    <Reveal effect='fadeInUp'>
      <Divider space={3} />
      <Link
        href={buttons[0].link}
        sx={styles.buttonContainer}
        target='_blank'
        rel='noreferrer'
      >
        <p css={css(styles.button)}>{buttons[0].text}</p>
        <Icon content={collection[0].icon} size='xxs' mt={'5px'} />
      </Link>
    </Reveal>
  </Container>
);

export default WithDefaultContent(FeaturesBlock07);
